import popupStyles from "./paymentLinkDisplayModal.module.css";
import { IPopupWithoutProps } from "../../../types/types";
import venchyImg from "../../../images/questionnaire_doctor.png";
import { tWithKeyAttr as t } from "../../../i18nHelper";
import { useState } from "react";

interface PaymentLinkDisplayModalProps extends IPopupWithoutProps {
  paymentUrl: string;
  userName: string;
}

function PaymentLinkDisplayModal({
  onClose,
  paymentUrl,
  userName,
}: PaymentLinkDisplayModalProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(paymentUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = paymentUrl;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const handleOpenLink = () => {
    window.open(paymentUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <article className={popupStyles.popup} data-testid="payment-link-display-popup">
      <img className={popupStyles.popup__img} src={venchyImg} alt={t('VENCHI')} />
      <h2 className={popupStyles.popup__title}>{t('PAYMENT_LINK_READY')}</h2>
      <p className={popupStyles.popup__subtitle}>
        {t('PAYMENT_LINK_FOR_USER', { userName })}
      </p>

      <div className={popupStyles.popup__linkContainer}>
        <input
          type="text"
          readOnly
          value={paymentUrl}
          className={popupStyles.popup__linkInput}
          onClick={(e) => (e.target as HTMLInputElement).select()}
        />
        <button
          className={`${popupStyles.popup__copyBtn} ${copied ? popupStyles.popup__copyBtn_copied : ''}`}
          onClick={handleCopy}
          title={t('COPY_LINK')}
        >
          {copied ? '✓' : '📋'}
        </button>
      </div>

      {copied && (
        <p className={popupStyles.popup__copiedMessage}>
          {t('LINK_COPIED')}
        </p>
      )}

      <div className={popupStyles.popup__buttons}>
        <button
          className={`button ${popupStyles.popup__openBtn} hover`}
          data-testid="open-payment-link-button"
          onClick={handleOpenLink}
        >
          {t('OPEN_LINK')}
        </button>
        <button
          className={`button ${popupStyles.popup__closeBtn} hover`}
          data-testid="close-payment-link-button"
          onClick={onClose}
        >
          {t('CLOSE')}
        </button>
      </div>
    </article>
  );
}

export default PaymentLinkDisplayModal;
